import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'; import { Spin, Tag } from 'antd';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { candleStickTranslation } from '../../../Utils/Adapter/translationAdapter';
dayjs.extend(utc);
dayjs.extend(timezone);

const CandleStick = (props) => {
  const getOption = () => {
    let { graphprops } = props;
    let theme = props.selectedThemeing;
    let stringRange = graphprops.singleCandleStick?.range || '[]';
    let range = JSON.parse(stringRange);
    let option = {
      xAxis: {
        data: [''],
        axisLine: {
          show: false,
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        nameTextStyle: {
          color: 'steelblue',
          fontSize: 20,
          padding: [10, 4, 5, 6]
        },
        textStyle: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white',
          fontSize: 15
        },
        name: '',
        nameLocation: 'center',
        axisTick: {
          show: false
        },
        type: 'category',
        show: true
      },
      yAxis: {
        min: -450,
        max: 450,
        interval: 150,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
            fontSize: 15
          }
        }
      },
      series: [
        {
          itemStyle: {
            color: graphprops.singleCandleStick?.titleColor?.[0] || [],
            borderColor: graphprops.singleCandleStick?.titleColor?.[0] || []
          },
          data: [
            [
              range[0] || -300,
              0,
              range[0] || -300,
              range[1] || 300
            ]
          ],
          type: 'candlestick',
          color: graphprops.singleCandleStick?.titleColor?.[0] || []
        }
      ],
      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: 'black',
            name: graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
    return option;
  };

  // Define getInitialState as a regular function
  const getInitialState = () => ({ option: getOption() });

  const [option, setOption] = useState(getInitialState().option);
  const [loading, setLoading] = useState(false);
  const [refreshDateTime, setRefreshDateTime] = useState(dayjs().tz("Asia/Kolkata"));
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);


  const getData = async () => {
    requestCheck.current = false;
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);

    let json = {};
    const optionClone = cloneDeep(option);
    setLoading(true);

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
      setLoading(false);
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json && Array.isArray(json) && json.length > 0) {
        let tag_description = await candleStickTranslation(json[0]?.Description, props.translationCache);

        let stringRange = graphprops.singleCandleStick?.range || '[]';
        let parsedRange = JSON.parse(stringRange);

        optionClone.yAxis.min = parsedRange[0];
        optionClone.yAxis.max = parsedRange[1];

        optionClone.series[0].data[0][1] = Number(json[0].Value).toFixed(2);
        optionClone.xAxis.data[0] = Number(json[0].Value).toFixed(2);
        optionClone.xAxis.name = `${tag_description} (${refreshDateTime.format('YYYY-MM-DD HH:mm:ss')})`;
        optionClone.series[0].itemStyle.color = graphprops.singleCandleStick?.titleColor?.[0];
      }
      setOption(optionClone);
      setRefreshDateTime(dayjs().tz("Asia/Kolkata"));
    }

    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? refreshDateTime.format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {!loading ? (
            <ReactEcharts
              option={option}
              style={{ height: '85%', width: '100%' }}
              className="react_for_echarts"
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: props.selectedThemeing === 'lightTheme' ? 'black' : 'white',
                marginTop: '15%'
              }}
            >
              <h2 style={{ color: props.selectedThemeing === 'lightTheme' ? 'black' : 'white' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(CandleStick);